(function () {
  'use strict';

  function initTrustbar(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.trustbar__slide'));
    if (slides.length < 2) return;

    var current = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (current < 0) current = 0;

    var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;

    function next() {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }

    function play() {
      if (!autoplay || reducedMotion) return;
      stop();
      timer = window.setInterval(next, speed);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', play);

    play();
  }

  function init() {
    document.querySelectorAll('.trustbar__rotator').forEach(initTrustbar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();